import {
    AfterViewInit,
    ChangeDetectorRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    Directive,
    Injector,
} from '@angular/core';
import { WidgetModel } from '@fi-app/widget/model/widget.model';
import { WidgetPlaceHolderControlModel } from '@fi-shared/widget/widget-place-holder-control.model';
import { Observable, Subject } from 'rxjs';
import { WidgetSharedService } from '@fi-shared/widget/widget-shared.service';
import { takeUntil } from 'rxjs/operators';

@Directive()
export abstract class WidgetBase implements AfterViewInit, OnInit, OnDestroy {
    protected cdr: ChangeDetectorRef;
    protected widgetSharedService: WidgetSharedService;
    constructor(private injector: Injector) {
        this.widgetSharedService = injector.get(WidgetSharedService);
        this.cdr = injector.get(ChangeDetectorRef);
    }

    @Input() widget: WidgetModel;
    @Input() control: WidgetPlaceHolderControlModel;
    @Input() languageId: number;

    @Output() afterViewInit = new EventEmitter<WidgetBase>();

    abstract get isEmpty$(): Observable<boolean>;

    ngAfterViewInit(): void {
        this.afterViewInit.emit(this);
    }

    ngOnInit(): void {
        this.widgetSharedService
            .getWidgetSettingsChanged$(() => this.control.Settings)
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe(() => {
                this.cdr.detectChanges();
            });
    }

    ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
